import { render, staticRenderFns } from "./TabsDashboardFlyRewards.vue?vue&type=template&id=ef737594&"
import script from "./TabsDashboardFlyRewards.vue?vue&type=script&lang=js&"
export * from "./TabsDashboardFlyRewards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports